import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import { UserType } from "app/types/userType";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

type Props = {
  user: UserType;
  error?: boolean;
  selectedTab: string;
  verified: boolean;
  onClickVerify: (...args: Array<any>) => any;
  onClickBack: (...args: Array<any>) => any;
};

export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

class FormSubmittedContent extends Component<Props> {
  componentDidMount() {
    this.addMutationObserver();
  }

  addMutationObserver() {
    console.log(this.props);
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Check if the target element exists
          const elements = document.querySelectorAll(
            ".form-submitted__content__info"
          );
          if (elements.length > 0) {
            // Trigger GeniusSiteTracking or similar functionality
            // You might want to directly call GeniusSiteTracking functionality here
            // However, usually, just ensuring the component is properly set up is enough
          }
        }
      }
    });

    // Observe changes in the document body
    observer.observe(document.body, { childList: true, subtree: true });
  }

  render(): React.ReactElement<React.ComponentProps<"div">, "div"> {
    const { error, selectedTab, verified, onClickVerify, onClickBack, user } =
      this.props;

    return (
      <div className="form-submitted__content">
        {selectedTab === TabTypes.DEPOSIT &&
          (user.firstTimeUser ? (
            <GeniusSiteTracking
              accountID={user.accountId}
              targetSelector=".form-submitted__content__info"
              eventType="change"
              pageName={"firstdepositconfirm"}
              trackPageLoad={true}
            />
          ) : (
            <GeniusSiteTracking
              accountID={user.accountId}
              targetSelector=".form-submitted__content__info"
              eventType="change"
              pageName={"depositconfirm"}
              trackPageLoad={true}
            />
          ))}
        {!error && (
          <div className="form-submitted__content__info">
            <div className="title">
              {selectedTab === TabTypes.DEPOSIT ? (
                <>
                  <FormattedMessage
                    tagName="span"
                    id="cashier-deposit-notification-ok"
                  />
                </>
              ) : (
                <FormattedMessage
                  tagName="span"
                  id="cashier-withdrawal-notification-ok"
                />
              )}
            </div>
            {!verified && selectedTab === TabTypes.WITHDRAW && (
              <React.Fragment>
                <FormattedMessage
                  tagName="span"
                  id="cashier-account-verified"
                />
                <div className="status">
                  <FormattedMessage
                    tagName="span"
                    id="cashier-current-status"
                  />
                  :{" "}
                  <FormattedMessage
                    tagName="span"
                    id="settings-account-unverified"
                  />
                </div>
              </React.Fragment>
            )}
          </div>
        )}
        {error && (
          <div className="form-submitted__content__info">
            <div className="title title--error">
              <FormattedMessage
                tagName="span"
                id="cashier-notification-error"
              />
            </div>
          </div>
        )}
        {!verified && !error && selectedTab === TabTypes.WITHDRAW && (
          <button
            id="verify-account__button"
            type="button"
            onClick={onClickVerify}
          >
            <FormattedMessage tagName="span" id="cashier-verify-account" />
          </button>
        )}
        <div className="form-submitted__content__links">
          <div className="new-transaction" onClick={onClickBack}>
            <FormattedMessage tagName="span" id="cashier-newtransaction" />
          </div>
          <Link to="/events" id="return-home">
            <FormattedMessage tagName="span" id="cashier-return-home" />
          </Link>
        </div>
      </div>
    );
  }
}

export default FormSubmittedContent;
